import { Component, OnInit, Input } from '@angular/core';
import { AgendaToggleService } from 'src/app/services/agenda-toggle.service';

@Component({
  selector: 'transflo-calendar-header',
  templateUrl: './calendar-header.component.html'
})
export class CalendarHeaderComponent implements OnInit {

  flagIsActive: boolean;
  agendaIsActive: boolean;
  @Input() calendarViewType: any;
  @Input() calendarView: any;

  constructor(
    private agendaToggleService: AgendaToggleService
  ) { }

  ngOnInit(): void {
    this.agendaToggleService.isFlaggedAgenda
      .subscribe(value => {
        this.flagIsActive = value;
        if (value) { this.agendaToggleService.calendarInitSubject.next(new Date()); }
      });
    this.agendaToggleService.isNormalAgenda
      .subscribe(value => {
        this.agendaIsActive = value;
        if (value) { this.agendaToggleService.calendarInitSubject.next(new Date()); }
      });
  }

  toggleView(viewIsActive: boolean): void {
    if (viewIsActive === false) {
      this.agendaToggleService.newFlagedValue(!this.flagIsActive);
      this.agendaToggleService.newNormalValue(!this.agendaIsActive);
    }
  }

}
